<template>
  <v-card elevation="3">
    <v-card-title>{{ opportunity.name }}</v-card-title>
    <v-card-text
      v-if="!opportunity.deleted"
      v-html="opportunity.text"
    ></v-card-text>
    <v-card-text v-else>
      <h2>
        This opportunity has been removed by the sponsor. Use the button below
        to remove your application.
      </h2>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <Apply
        v-if="
          opportunity.applications.length < 1 &&
            !uploading &&
            opportunity.open &&
            opportunity.applyOnPortal
        "
        v-on:apply="apply"
      >
      </Apply>
      <v-btn
        color="success"
        v-if="!opportunity.applyOnPortal"
        target="_blank"
        :href="opportunity.applyLink"
        >Apply Externally</v-btn
      >

      <div class="d-flex" v-if="uploading">
        <v-flex class="ml-auto align-self-end">
          <small>
            Uploading your documents. Please do not refresh.
          </small>
        </v-flex>
        <v-flex>
          <v-progress-circular
            :rotate="-90"
            :size="50"
            :width="8"
            :value="(uploadcount / filesAmount) * 100"
            color="primary"
          >
          </v-progress-circular>
        </v-flex>
      </div>
      <v-flex v-if="opportunity.applications.length < 1 && !opportunity.open">
        Applications are closed for this opportunity
      </v-flex>
      <div
        v-if="
          opportunity.applications.length >= 1 &&
            !uploading &&
            !opportunity.applications[0].rejected &&
            !opportunity.applications[0].nextStep
        "
      >
        <v-btn color="error" @click="unapply">Remove Application</v-btn>
      </div>
    </v-card-actions>
    <v-stepper
      vertical
      class="pb-1"
      v-if="
        $vuetify.breakpoint.xsOnly &&
          opportunity.applications.length >= 1 &&
          !uploading
      "
    >
      <Steps :application="opportunity.applications[0]"></Steps>
    </v-stepper>
    <v-stepper
      v-if="
        !$vuetify.breakpoint.xsOnly &&
          opportunity.applications.length >= 1 &&
          !uploading
      "
    >
      <v-stepper-header>
        <Steps :application="opportunity.applications[0]"></Steps>
      </v-stepper-header>
    </v-stepper>
  </v-card>
</template>

<script>
import Apply from "./Apply";
import { storage } from "@/plugins/firebase";
import Steps from "./Steps";

export default {
  fiery: true,
  props: ["opportunity"],
  components: { Apply, Steps },
  data() {
    return {
      uploading: false,
      uploadcount: 0,
      filesAmount: 1
    };
  },
  methods: {
    apply: function(form, files) {
      this.uploading = true;
      var application = this.$fiery.buildSub(
        this.opportunity,
        "applications",
        form
      );
      let path = "CVs/" + application[".uid"] + "/";
      this.uploadcount = 0;
      this.filesAmount = files.length;
      application.files = [];
      Promise.all(
        files.map(file => {
          return storage
            .child(path + file.name)
            .put(file)
            .then(snapshot => {
              snapshot.ref.getDownloadURL().then(downloadURL => {
                application.files.push({
                  name: file.name,
                  download: downloadURL
                });
              });
              this.uploadcount++;
            });
        })
      ).then(() => {
        setTimeout(() => {
          this.$fiery.save(application);
          this.uploading = false;
        }, 400);
      });
    },
    unapply: function() {
      let files = this.opportunity.applications[0].files;
      Promise.all(
        files.map(file => {
          return storage
            .child(
              "CVs/" +
                this.opportunity.applications[0][".uid"] +
                "/" +
                file.name
            )
            .delete();
        })
      )
        .then(() => {
          this.$fiery.remove(this.opportunity.applications[0]);
        })
        .catch(() => {
          console.log("Internal server error, attempting repair");
          this.$fiery.remove(this.opportunity.applications[0]);
        });
    }
  }
};
</script>